import React from 'react';
import { Sticky, Container } from 'basis';
import { Header, Footer, ProgressStepper } from 'components';
import { Step } from 'types';
import { useAppContext, useInactivityTimeout } from 'hooks';
import { InactivityTimeoutModal } from '../session/InactivityTimeoutModal';

type Props = {
  children: React.ReactNode;
  step: Step;
  hideProgressStepper?: boolean;
  paddingBottom?: number;
  inactivityTimeout?: boolean;
};

export const LayoutPage: React.FC<Props> = ({ children, hideProgressStepper: propsHideProgressStepper, step, paddingBottom, inactivityTimeout = process.env.REACT_APP_ENV !== 'dev' }) => {
  const { state } = useAppContext();
  const { showWarning, secondsRemaining, handleContinueSession, handleExitSession } = useInactivityTimeout({ enable: inactivityTimeout });
  const hideProgressStepper = propsHideProgressStepper || ['acceptance', 'additional-card-holder-identity-verification', 'additional-card-holder-upload-documents'].includes(state.flow);
  return (
    <>
      <Sticky>
        <Sticky.Item>
          <Header />
        </Sticky.Item>
        {!hideProgressStepper && (
          <Sticky.Item>
            <ProgressStepper step={step} />
          </Sticky.Item>
        )}
        {inactivityTimeout && (
          <InactivityTimeoutModal
            showWarning={showWarning}
            secondsRemaining={secondsRemaining}
            handleContinueSession={handleContinueSession}
            handleExitSession={handleExitSession}
          />
        )}
      </Sticky>
      <main>
        <Container testId="LayoutPage.Main.ContentContainer" width="100%"
          padding={`${hideProgressStepper ? 8 : 0} 0 ${paddingBottom ?? 10} 0`}
          padding-md={`${hideProgressStepper ? 12 : 0} 0 ${paddingBottom ?? 12} 0`}
        >
          {children}
        </Container>
      </main>
      <Footer />
    </>
  );
};
